export default "__VITE_ASSET__X0UKZsXl__"